import {
  Box,
  Button,
  Card,
  CardMedia,
  Container,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
//import recipes from "../data/recipes";
import { CheckCircle } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { fetchRecipeById } from "../firebase/fireStoreServices";

export default function RecipeDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const selectedVideo = "https://youtu.be/6_zf42ved44";

  // Fetching Recipe data from database through service layer i.e. firebase/fireStoreServices
  const [recipeData, SetRecipeData] = useState(null);
  useEffect(() => {
    const loadRecipe = async () => {
      const recipeData = await fetchRecipeById(id);
      SetRecipeData(recipeData);
    };
    loadRecipe();
  }, [id]);

  //const recipe = recipes.find((r) => r.id === Number(id));
  //const recipe = recipesData.find((r) => r.id === id);

  if (!recipeData) {
    return (
      <Box sx={{ maxWidth: 800, margin: "auto" }}>
        <Button onClick={() => navigate("/recipes")} sx={{ mb: 2 }}>
          Back to Recipes
        </Button>
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, backgroundColor: "primary" }}>
      <Card>
        <CardMedia
          component="img"
          image={recipeData.image}
          alt={recipeData.title}
          loading="lazy"
        />
      </Card>

      <Card sx={{ mt: 4, boxShadow: 5 }}>
        <Typography
          variant="h4"
          sx={{ mt: 4, fontWeight: "bold", textAlign: "center" }}
        >
          {recipeData.title}
        </Typography>
        <Typography
          variant="body1"
          color="secondary"
          sx={{ mt: 2, textAlign: "center" }}
        >
          {recipeData.description}
        </Typography>
      </Card>

      <Typography
        variant="h5"
        color="secondary"
        sx={{ mt: 2, fontWeight: "bold", mb: 1 }}
      >
        Ingredients:
      </Typography>
      <Card sx={{ boxShadow: 5, bgcolor: "#F5F5F5" }}>
        {recipeData.ingredients?.map((ingredient, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <CheckCircle color="success" />
            </ListItemIcon>
            <ListItemText primary={ingredient} />
          </ListItem>
        ))}
      </Card>

      <Typography
        variant="h5"
        color="secondary"
        sx={{ fontWeight: "bold", mt: 3, mb: 1 }}
      >
        Steps to follow:
      </Typography>

      <Card sx={{ boxShadow: 5, bgcolor: "#F5F5F5" }}>
        {recipeData.steps.map((step, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <CheckCircle color="success" />
            </ListItemIcon>
            <ListItemText primary={`${index + 1}. ${step}`} />
          </ListItem>
        ))}
      </Card>

      <Card sx={{ mt: 4, boxShadow: 5 }}>
        <Typography
          variant="h4"
          sx={{ mt: 4, fontWeight: "bold", textAlign: "center" }}
        >
          Youtube Video:
        </Typography>

        <Box sx={{ my: 4, textAlign: "center", boxShadow: 3, borderRadius: 2 }}>
          <iframe
            width="100%"
            height="400"
            src={`https://www.youtube.com/embed/${recipeData.videoURL.replace(
              "https://youtu.be/",
              ""
            )}?autoplay=0&rel=0`}
            title="YouTube Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      </Card>

      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)}
        sx={{ mt: 2 }}
      >
        Back
      </Button>
    </Container>
  );
}
